import { toastService } from 'components/molecules/toast';
import { Translate } from 'hooks/use-translation';

export const formAnswerSubmissionFailureToast = (
  status: number,
  translate: Translate<string>,
) => {
  switch (status) {
    /* 
      422 status code will be returned when we are trying to submit more than
      one response for a form which is configured to accept only one response
      */
    case 422:
      toastService({
        title: translate('forms.response_already_submitted.title'),
        message: translate('forms.response_already_submitted.message'),
      }).error();
      break;
    default:
      toastService({
        title: translate('forms.response_submitted_failure'),
        message: '',
      }).error();
  }
};
